import P from '../pages';
import FormHeader from './FormHeader';
import Alert from './Alert';
import { defaultMessages } from '../../../libs/i18n/default';
import FormControl from 'react-bootstrap/lib/FormControl';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import { CustomFormGroup, Form } from '../../../shared/components';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { pageValid, fieldsToValidate } from '../../../shared/validator';
import { guestProfileSubmit } from '../actions';
import withDefaults from './withDefaults'
import { changeState, yesNoOptions, optionsFromArray } from '../../../shared/utilities';
import { generateProfileElementObject, setProfileElementsFromState } from '../../../shared/profileElementHelpers';
import { ameOrUsa } from '../helpers'

const Placement = ({ content, dispatch, page, user, territory, environment, intl: { formatMessage } }) => {
  const thisPage = P.PLACEMENT_PAGE;
  const [submitted, setSubmitted] = useState(false)
  const lengthSelections = useSelector(state => state.localProfileElements.elements.placement.length_selections)
  const numberOfBags = useSelector(state => state.localProfileElements.elements.placement.bags_selections)
  const profileElements = useSelector(state => state.profileElements)
  const placementEntry = profileElements.find(entry => entry.kind === "placement")
  const intendedStart = placementEntry?.answers?.intended_start
  const lengthHighSchoolSelections = useSelector(state => state.localProfileElements.elements.placement.length_high_school_selections)
  const [fields, setFields] = useState({
    length: generateProfileElementObject('', 'placement', 'length'),
    lengthHighSchool: generateProfileElementObject('', 'placement', 'length_high_school'),
    lengthHighSchoolOther: {
      val: setProfileElementsFromState('', 'placement', 'length_high_school_other'),
      validationKey: 'profile_elements_placement_length_high_school_other',
      profileElement: 'length_high_school',
      dependentObj: 'lengthHighSchool',
      dependencyMet: (dependentObj = fieldsRef.current.lengthHighSchool) => (dependentObj.val == 'Other')
    },
    airportPickupRequired: {
      ...generateProfileElementObject('', 'placement', 'airport_pickup_required'),
      profileElement: !ameOrUsa(territory) && 'airport_pickup_required'
    },
    airportPickupBags: generateProfileElementObject('', 'placement', 'airport_pickup_bags'),
    departureTransport: generateProfileElementObject('', 'placement', 'departure_transport'),
    comments: generateProfileElementObject('', 'placement', 'comments'),
  })
  const fieldsRef = useRef(fields)
  fieldsRef.current = fields

  useEffect(() => {
    fieldsToValidate(fields).forEach(f => {
      handleChange(f, fields[f].val, false)
    })
  }, [])

  const handleChange = (key, val, resetDependentObject = true) => {
    changeState(
      fieldsRef.current,
      key,
      val,
      (newObj) => {
        setFields({...fieldsRef.current, ...newObj})
      },
      resetDependentObject
    )
  }

  const submit = (e) => {
    e.preventDefault()
    setSubmitted(true)
    dispatch(guestProfileSubmit({
      placement: {
        length: fields.length.val,
        length_high_school: fields.lengthHighSchool.val,
        length_high_school_other: fields.lengthHighSchoolOther.val,
        airport_pickup_required: fields.airportPickupRequired.val,
        airport_pickup_bags: fields.airportPickupBags.val,
        departure_transport: fields.departureTransport.val,
        comments: fields.comments.val
      }
    }, thisPage))
  }

  const infoOne = () => (
    content.pages.placement[`info_${user.guest.type.code}`] &&
    <Alert alert={content.pages.placement[`info_${user.guest.type.code}`]} />
  )

  const infoTwo = () => (
    content.pages.placement[`info_two_${user.guest.type.code}`] &&
    <Alert alert={content.pages.placement[`info_two_${user.guest.type.code}`]} />
  )

  return (
    <Form page={page} thisPage={thisPage} back={true} skip={environment != 'production'} submitFunc={submit} disableSubmit={!pageValid(fields) || submitted} >
      <FormHeader title={content.pages.placement.title} />

      <CustomFormGroup field={fields.length}>
        <ControlLabel>{content.pages.placement.length_label}</ControlLabel>
        <FormControl id="length"
          type="select"
          componentClass="select"
          defaultValue={fields.length.val}
          onChange={e => handleChange(e.target.id, e.target.value)}>
          {optionsFromArray(lengthSelections, formatMessage)}
        </FormControl>
      </CustomFormGroup>

      <CustomFormGroup field={fields.lengthHighSchool}>
        <ControlLabel>{formatMessage(defaultMessages.clientGuestPagesPlacementLabelsPlacementLength)}</ControlLabel>
        <FormControl id="lengthHighSchool"
          type="select"
          componentClass="select"
          defaultValue={fields.lengthHighSchool.val}
          onChange={e => handleChange(e.target.id, e.target.value)}>
          {optionsFromArray(lengthHighSchoolSelections, formatMessage)}
        </FormControl>
      </CustomFormGroup>

      <CustomFormGroup field={fields.lengthHighSchoolOther}>
        <ControlLabel>{formatMessage(defaultMessages.clientCommonOther)}</ControlLabel>
        <FormControl id="lengthHighSchoolOther"
          type="text"
          componentClass="input"
          defaultValue={fields.lengthHighSchoolOther.val}
          onChange={(e) => handleChange(e.target.id, e.target.value)}/>
      </CustomFormGroup>

      <CustomFormGroup field={fields.airportPickupRequired}>
        <ControlLabel>{content.pages.placement.apu_label}</ControlLabel>
        <FormControl id="airportPickupRequired"
          type="select"
          componentClass="select"
          defaultValue={fields.airportPickupRequired.val}
          onChange={e => handleChange(e.target.id, e.target.value)}>
          {yesNoOptions(formatMessage, false)}
        </FormControl>
      </CustomFormGroup>

      { fields.airportPickupRequired.val == 'Yes' &&
        <CustomFormGroup field={fields.airportPickupBags}>
          <ControlLabel>{content.pages.placement.bags_label}</ControlLabel>
          <FormControl id="airportPickupBags"
                       type="select"
                       componentClass="select"
                       defaultValue={fields.airportPickupBags.val}
                       onChange={e => handleChange(e.target.id, e.target.value)}>
            {optionsFromArray(numberOfBags, formatMessage)}
          </FormControl>
        </CustomFormGroup>
      }

      { intendedStart &&
        <CustomFormGroup field={fields.departureTransport}>
          <ControlLabel>{content.pages.placement.departure_transport_label}</ControlLabel>
          <FormControl id="departureTransport"
                       type="select"
                       componentClass="select"
                       defaultValue={fields.departureTransport.val}
                       onChange={e => handleChange(e.target.id, e.target.value)}>
            {yesNoOptions(formatMessage, false)}
          </FormControl>
        </CustomFormGroup>
      }

      { content.territory_code != "asc" && 
        <CustomFormGroup field={fields.comments}>
          <ControlLabel>{formatMessage(defaultMessages.clientCommonComments)}</ControlLabel>
          <FormControl id="comments"
            type="text"
            componentClass="textarea"
            defaultValue={fields.comments.val}
            onChange={e => handleChange(e.target.id, e.target.value)}/>
        </CustomFormGroup>
      }

      {infoOne()}
      {infoTwo()}
    </Form>
  )
}

export default withDefaults(Placement)
